export default "__VITE_ASSET__Csxbg8jk__"